//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from "@/request/index";
import { getUrlparams, countDownTimeFunc, toCopy } from "@/utils/util.js";
import footerNav from "@/components/footerNav";
import { Dialog, Toast } from "vant";
import homeTip from "@/components/homeTip";

export default {
  name: "report",
  components: {
    footerNav,
    homeTip
  },
  data() {
    return {
      toCopy,
      searchValue: "",
      loading: false,
      finished: false,
      refreshing: false,
      obj: [],
      list: []
    };
  },
  created() {
    // this.onLoad()
  },
  mounted() {},
  methods: {
    hasBtn(id) {
      var obj = false;
      this.$store.state.menus.forEach(item => {
        if (item.title == "送货单") {
          item.requestUrlList.forEach(element => {
            if (element.id == id) {
              obj = true;
            }
          });
        }
      });
      return obj;
    },
    onLoad() {
      // getSendOrderList
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      var params = {
        searchValue: this.searchValue,
        start: this.list.length,
        size: 10,
        orderRules: [
          { orderKey: "statussort", desc: false },
          { orderKey: "sendOrderId", desc: true }
        ],
        desc: true
      };
      axiosApi.getSendOrderList(params).then(res => {
        if (res.content.list && res.content.list.length > 0) {
          res.content.list.forEach(item => {
            var channelStr = "";
            if (item.firstDeptName) {
              channelStr += item.firstDeptName;
            }
            if (item.secondDeptName) {
              channelStr += "/" + item.secondDeptName;
            }
            item.channelStr = channelStr;
          });
          this.list = this.list.concat(res.content.list);
        }
        this.loading = false;
        this.refreshing = false;
        if (this.list.length == res.content.total) {
          this.finished = true;
        }
      });
    },
    onSearch() {
      this.list = [];
      this.onLoad();
    },
    toDetail(sendOrderId, item) {
      if (item.sendOrderStatus == 0) {
        this.$router.push({
          name: "editSendOrder",
          query: { sendOrderId: sendOrderId }
        });
      } else {
        this.$router.push({
          name: "warehouseGet",
          query: {
            sendOrderId: sendOrderId,
            type: item.sendOrderStatus == 1 ? 1 : 2
          }
        });
      }
    },
    toGet(sendOrderId) {
      this.$router.push({
        name: "warehouseGet",
        query: { sendOrderId: sendOrderId }
      });
    },
    clickBtn() {
      Dialog.confirm({
        title: "提示",
        message: "确认进行此操作"
      })
        .then(() => {
          Toast.success("成功");
        })
        .catch(() => {
          Toast.fail("已取消");
        });
    },
    copySuccess() {
      Toast.success("复制成功");
    },
    add() {
      this.$router.push({ name: "sendOrderAdd" });
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/sendOrder/index.vue